/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContextBlockMemberView } from './ContextBlockMemberView';

/**
 * One assembled block, flattened for the wire. `layer`/`lifecycle`
 * are derived server-side so the FE renders chips without re-deriving.
 * `members` are an episode container's resolved member turns (empty for
 * non-episode blocks).
 */
export type ContextBlockView = {
  type: ContextBlockView.type;
  variant: string | null;
  status: 'open' | 'closed' | null;
  source: string;
  layer: ContextBlockView.layer;
  lifecycle: ContextBlockView.lifecycle;
  role: string;
  content: string;
  members?: Array<ContextBlockMemberView>;
};
export namespace ContextBlockView {
  export enum type {
    INSTRUCTION = 'instruction',
    DATA = 'data',
    MESSAGE = 'message',
    ARTIFACT = 'artifact',
    QUERY = 'query',
  }
  export enum layer {
    INSTRUCTIONS = 'instructions',
    RETRIEVED = 'retrieved',
    MEMORY = 'memory',
    QUERY = 'query',
  }
  export enum lifecycle {
    STATIC = 'static',
    LIVE = 'live',
    PERSISTED = 'persisted',
    TURN = 'turn',
  }
}
